import { associateVoices } from './associate-voices.service';
import { getVoices } from './get-voices.service';

export const voicesService = {
  getVoices,
  associateVoices,
};
